document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".spin360-product").forEach(initSpin360);
});

// Survive the theme editor / quick-view re-injecting the section
document.addEventListener("shopify:section:load", (e) => {
  e.target.querySelectorAll(".spin360-product").forEach(initSpin360);
});

function initSpin360(root) {
  if (root.dataset.spin360Init === "true") return; // guard double-init
  root.dataset.spin360Init = "true";

  const variantRows      = root.querySelectorAll(".variant-row");
  const addToCartBtn     = root.querySelector(".add-to-cart");
  const purchaseOptions  = root.querySelectorAll(".option");
  const sellingPlanSelect = root.querySelector(".selling-plan");
  const purchaseTypeDiv  = root.querySelector(".purchase-type");
  const planSelectionDiv = root.querySelector(".plan-selection");
  const errorEl          = root.querySelector(".sp-error");

  const MINIMUM_PODS = parseInt(root.dataset.minimumPods, 10) || 3;

  // Format money through Shopify so symbol + market conversion match the rest of the store
  function fmt(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    // Fallback if the theme doesn't expose formatMoney
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: window.Shopify?.currency?.active || root.dataset.currency || "USD",
    }).format((cents || 0) / 100);
  }

  let purchaseType = "subscription";
  let isAddingToCart = false;

  const state = {};    // variantId -> raw quantity (what the cart receives)
  const weight = {};   // variantId -> pods it contributes to the minimum

  const cartRules = {
    getTotalPods() {
      return Object.keys(state).reduce(
        (sum, id) => sum + state[id] * (weight[id] || 1),
        0
      );
    },
    canAddToCart() { return this.getTotalPods() >= MINIMUM_PODS; },
    remainingPods() { return Math.max(0, MINIMUM_PODS - this.getTotalPods()); },
    hasSelections() { return this.getTotalPods() > 0; },
  };

  // INIT VARIANTS
  variantRows.forEach((row) => {
    const id     = row.dataset.variantId;
    const addBtn = row.querySelector(".add-btn");
    const qtyBox = row.querySelector(".qty-box");
    const qtyEl  = row.querySelector(".qty");

    state[id]  = 0;
    weight[id] = parseInt(row.dataset.podCount, 10) || 1;

    addBtn.addEventListener("click", () => {
      state[id] = 1;
      qtyEl.textContent = 1;
      addBtn.style.display = "none";
      qtyBox.classList.remove("hidden");
      updateAll();
    });

    row.querySelector(".plus").addEventListener("click", () => {
      state[id]++;
      qtyEl.textContent = state[id];
      updateAll();
    });

    row.querySelector(".minus").addEventListener("click", () => {
      state[id]--;
      if (state[id] <= 0) {
        state[id] = 0;
        qtyEl.textContent = 1;
        qtyBox.classList.add("hidden");
        addBtn.style.display = "inline-block";
      } else {
        qtyEl.textContent = state[id];
      }
      updateAll();
    });
  });

  // PURCHASE TYPE SWITCH (click + keyboard)
  function selectPurchaseType(opt) {
    purchaseOptions.forEach((o) => {
      o.classList.remove("active");
      o.setAttribute("aria-checked", "false");
    });
    opt.classList.add("active");
    opt.setAttribute("aria-checked", "true");
    purchaseType = opt.dataset.type;
    updatePlanVisibility();
    updatePrices();
  }

  purchaseOptions.forEach((opt) => {
    opt.addEventListener("click", () => selectPurchaseType(opt));
    opt.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        selectPurchaseType(opt);
      }
    });
  });

  // BUTTON STATE
  function updateButtonState() {
    if (!cartRules.canAddToCart()) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("is-disabled");
      const remaining = cartRules.remainingPods();
      addToCartBtn.textContent =
        remaining === 1 ? "Add 1 More Scent Pod" : `Add ${remaining} More Scent Pods`;
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove("is-disabled");
      addToCartBtn.textContent = "Add to Cart";
    }
  }

  function togglePurchaseTypeVisibility() {
    purchaseTypeDiv.classList.toggle("is-locked", !cartRules.hasSelections());
  }

  function updatePlanVisibility() {
    planSelectionDiv.classList.toggle("is-locked", !cartRules.hasSelections());
    planSelectionDiv.style.display = purchaseType === "subscription" ? "block" : "none";
  }

  // PRICE + COMPARE (read from the selling-plan allocation, never computed)
  function updatePrices() {
    let oneTime = 0, subTotal = 0, subCompare = 0;

    variantRows.forEach((row) => {
      const id  = row.dataset.variantId;
      const qty = state[id];
      if (!qty) return;
      const price   = parseInt(row.dataset.price, 10) || 0;
      const subP    = parseInt(row.dataset.subPrice, 10) || price;
      const subComp = parseInt(row.dataset.subCompare, 10) || price;
      oneTime    += price * qty;
      subTotal   += subP * qty;
      subCompare += subComp * qty;
    });

    root.querySelector(".subscription-price").innerHTML =
      `${fmt(subTotal)} <span class="compare-price">${fmt(subCompare)}</span>`;
    root.querySelector(".onetime-price").textContent = fmt(oneTime);
  }

  function resetProductForm() {
    variantRows.forEach((row) => {
      const id = row.dataset.variantId;
      state[id] = 0;
      row.querySelector(".qty").textContent = 1;
      row.querySelector(".qty-box").classList.add("hidden");
      row.querySelector(".add-btn").style.display = "inline-block";
    });
    updateAll();
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || "";
    errorEl.hidden = !msg;
  }

  function updateAll() {
    updatePrices();
    updateButtonState();
    togglePurchaseTypeVisibility();
    updatePlanVisibility();
  }

  updateAll();

  // ADD TO CART
  addToCartBtn.addEventListener("click", async () => {
    if (isAddingToCart || !cartRules.canAddToCart()) return;
    showError("");

    // Validate the selling plan before building a payload
    let sellingPlanId = null;
    if (purchaseType === "subscription") {
      sellingPlanId = Number(sellingPlanSelect && sellingPlanSelect.value);
      if (!sellingPlanId) {
        showError("Please choose a delivery plan.");
        return;
      }
    }

    // Raw quantities only — the pod weight NEVER becomes the line quantity
    const items = Object.keys(state)
      .filter((id) => state[id] > 0)
      .map((id) => {
        const item = { id: Number(id), quantity: state[id] };
        if (sellingPlanId) item.selling_plan = sellingPlanId;
        return item;
      });

    if (items.length === 0) return;

    isAddingToCart = true;
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add("disabled");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || "Could not add to cart.");
      }

      await response.json();
      resetProductForm();
      document.dispatchEvent(new CustomEvent("cart:open"));
    } catch (error) {
      console.error("[Add To Cart Error]", error);
      showError(error.message || "Something went wrong. Please try again.");
    } finally {
      isAddingToCart = false;
      addToCartBtn.classList.remove("disabled");
      updateButtonState();
    }
  });
}